import "./App.css";
import Ants from "./Ants.js";
import BinaryTrail from "./BinaryTrail.js";
import Header from "./components/Header/Header.js";
import Hero from "./components/Hero/Hero.js";
import MobileTabBar from "./components/MobileTabBar/MobileTabBar.js";
import Multipaltyping from "./Multipal-typing.js";
import GlowingCards from "./Glowing-Cards.js";
import Brandslider from "./Brand-slider.js";
import Footer from "./Footer.js";
import { useTheme } from "./hooks/useTheme.js";
import { useReveal } from "./hooks/useReveal.js";
import { useActiveSection } from "./hooks/useActiveSection.js";
import { NAV_LINKS } from "./constants/navLinks.js";

const SECTION_IDS = NAV_LINKS.map((l) => l.href.slice(1));

const App = () => {
  const { theme, toggleTheme } = useTheme();
  const activeId = useActiveSection(SECTION_IDS);
  useReveal();

  return (
    <div className="App">
      <Ants />
      <BinaryTrail />
      <Header activeId={activeId} theme={theme} onToggleTheme={toggleTheme} />
      <Hero />
      <Multipaltyping />
      <GlowingCards />
      <Brandslider />
      <Footer />
      <MobileTabBar activeId={activeId} />
    </div>
  );
};

export default App;
